// extracted by mini-css-extract-plugin
module.exports = {"lead":"typography-module--lead--1mWbk","smallprint":"typography-module--smallprint--2gN2d"};